/**
 * Attempts to save a value to localStorage, falling back to sessionStorage if localStorage fails
 */
export const setStorageValue = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    try {
      sessionStorage.setItem(key, value);
    } catch (fallbackError) {
      console.warn(
        "Failed to save to both localStorage and sessionStorage:",
        fallbackError,
      );
    }
  }
};

/**
 * Retrieves a value from storage, checking localStorage first then sessionStorage
 */
export const getStorageValue = (key: string): string | null => {
  try {
    const localValue = localStorage.getItem(key);
    if (localValue !== null) {
      return localValue;
    }
  } catch {
    // Ignore localStorage errors and try sessionStorage
  }

  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    console.warn(
      "Failed to read from both localStorage and sessionStorage:",
      error,
    );
    return null;
  }
};

export const removeStorageValue = (key: string): void => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};
